"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreDesiredOutcome = void 0;
var CoreDesiredOutcome;
(function (CoreDesiredOutcome) {
    CoreDesiredOutcome["CLIENT_RELEASE_FUNDS"] = "CLIENT_RELEASE_FUNDS";
    CoreDesiredOutcome["REVISION_REWORK"] = "REVISION_REWORK";
    CoreDesiredOutcome["PARTIAL_REFUND"] = "PARTIAL_REFUND";
    CoreDesiredOutcome["FULL_REFUND"] = "FULL_REFUND";
    CoreDesiredOutcome["OTHER"] = "OTHER";
})(CoreDesiredOutcome || (exports.CoreDesiredOutcome = CoreDesiredOutcome = {}));
